import { createSelector } from 'reselect';

export const auditLogsSelector = createSelector(
    (state) => state && state.audit && state.audit.logs,
    (logs) => logs || []
);

export const weeklyReportAuditLogsSelector = createSelector(
    (state) => state && state.audit && state.audit.weeklyReportLogs,
    (logs) => logs || []
);
